export default __webpack_public_path__ + "static/media/image3.1bad5891.jpg";